import React from "react";
import {injectIntl} from "react-intl";

class MSStreamLoader extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const loaderStyle = {
      width: '100%',
      height: '100%',
    };
    return (
      <div className="ui segment embedded-seg" style={loaderStyle}>
        <div id={this.props.divId} style={{backgroundColor: "#a2a2a2"}}></div>
        <div className="ui active dimmer show-loading">
          <div className="ui loader"></div>
        </div>
      </div>
    )
  }
}
export default injectIntl(MSStreamLoader);
